import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const Col = ({ className, children, style, size = ["sm-12"] }) => (
  <div
    className={classNames(
      size.map(el => `col-${el}`),
      className
    )}
    style={style}
  >
    {children}
  </div>
);

Col.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node.isRequired,
};

Col.defaultProps = {
  className: undefined,
};

export default Col;
